/**
 * Warm authenticated route modules during idle time, before a user navigates to them.
 * Call only through usePrefetchAuthenticatedRoutes: every page listed here is protected.
 *
 * The 2026-09-09 production-bundle A/B recorded 78 JS chunks on /signIn with
 * prefetch, versus 16 without it (62 fewer requests). Median FCP was 2,112 ms
 * versus 1,847 ms, with overlapping runs; this did not explain the 7,165 ms lab LCP.
 * See scio3!2995 for the measurement setup and limitations.
 *
 * requestIdleCallback can run before first paint, so idle scheduling alone does
 * not protect the login page from unnecessary downloads. The auth gate does.
 */
export function prefetchRouteChunks(): void {
  const prefetch = () => {
    // Templates page (lightweight but frequently accessed)
    import('@/features/templates/pages/TemplatesPage').catch(() => {});
    // Designer page (heavy — many dialog/bridge imports)
    import('@/features/designer/pages/DesignerPage').catch(() => {});
    // MDM Devices page (heavy — actions catalog + classification + capability diagnostic)
    import('@/features/mdm-devices/pages/DevicesPage').catch(() => {});
    // Assets page (#1229)
    import('@/features/assets/pages/AssetsPage').catch(() => {});
    // Playlists page (#1229 — the largest page chunk in the app, ~149 kB)
    import('@/features/playlists/pages/PlaylistsPage').catch(() => {});
    // Schedules page (#1229 — ~122 kB)
    import('@/features/schedules/pages/SchedulesPage').catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetch);
  } else {
    // Safari fallback
    setTimeout(prefetch, 2000);
  }
}
